// extracted by mini-css-extract-plugin
export var center = "_5d-2";
export var clickableRow = "_5d-5";
export var expandedRow = "_5d-7";
export var hoverable = "_5d-4";
export var left = "_5d-1";
export var right = "_5d-3";
export var row = "_5d-0";
export var selectedRow = "_5d-6";
export var summaryRow = "_5d-8";